<template>
    <div>
        <p class="label">{{ label }}</p>
        <MultiplePickerInput :value="value" @input="onInput" :items="items" v-bind="$attrs" />
    </div>
</template>

<script>
  import MultiplePickerInput from '@/components/inputs/MultiplePickerInput.vue';
  import StudentService from '@/services/student.service.js'

  export default {
    name: "YearMultiplePickerInput",
    components: {
      MultiplePickerInput,
    },
    props: {
      value: {},
      label: { type: String, default: 'Rentrée scolaire'}
    },
    data() {
      return {
        items: [],
      }
    },
    created() {
      this.loadListItem();
    },
    methods: {
      loadListItem() {
        const _this = this;

        StudentService.getListYear().then(({data}) => {
          _this.items = data;
        });
      },
      onInput(event) {
        this.$emit('input', event);
      }
    },
  }
</script>

<style scoped>

</style>
